/* eslint-disable consistent-return */
/* eslint-disable no-useless-return */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { DragHandle, PanTool, Phone, PhoneTwoTone, Publish, SentimentSatisfied, SentimentSatisfiedAltTwoTone, SentimentSatisfiedTwoTone, SentimentVerySatisfiedTwoTone } from '@material-ui/icons';
import hash from 'object-hash';
import { ClickAwayListener, Tooltip } from '@material-ui/core';
import { donutChartOptions, needle, formatSecondsToDuration, QuickWidget, Widget, chartBgs } from './Utilities';
import { QueueCallState } from '../QueueLeaderboard';
import { ILayoutValues } from './Widget';
import rcimg from './270-2702502_ringcentral-logo-transparent.png'
import { sentimentBgs } from '../C2GReport';


export const CallResultsWidget = ({ widgetContent, styles, deltas , cosmetics}: { styles: any; deltas: Map<string, any> ; cosmetics: QuickWidget['cosmetics'], widgetContent: Widget | undefined}) => {
  const [widgetData, setWidgetData] = useState<{ datasets: Array<{ data: string[] }>; labels: string[] } | undefined>(
    undefined,
  );

  useEffect(() => {
    const resultObj = Array.from(deltas.values()).reduce(
      (acc, value) => ({
        complete: (acc.complete + (value.talkCountInbound || 0) + (value.talkCountOutbound || 0) + (value.talkCountInternal || 0)),
        missed: acc.missed + (value.missedCount || 0),
      }),
      {
        complete: 0,
        missed: 0,
      },
    );
    // console.log('DELTAS: ', deltas)
    // const labels = Array.from(Object.keys(resultObj || {})).map((key) => {
    //   console.log
    //   return `key: ${val}`
    // })

    setWidgetData(() => ({
        datasets: [
            {
                data: Object.values(resultObj || {}),
                backgroundColor: chartBgs,
                borderColor: chartBgs,
            },
        ],
        labels: Object.keys(resultObj || {})
    }));
  }, [deltas]);
  if (!widgetData) return <></>;

  return (
    <div className={styles.gridItemContainerInner}>        
      <div className={styles.gridItemBody}>
        <Doughnut
          options={donutChartOptions as any}
          data={widgetData as any}
        />
        </div>
    </div>
  );
};
export const CallDirectionCountWidget = ({styles, deltas , cosmetics}: { styles: any, deltas: Map<string, any> ; cosmetics: QuickWidget['cosmetics']}) => {
  const [widgetData, setWidgetData] = useState<{ datasets: Array<{ data: string[] }>; labels: string[] } | undefined>(undefined);

  useEffect(() => {
    const resultObj = Array.from(deltas.values()).reduce(
      (acc, value) => ({
        inbound: (acc.inbound + ((value.ringCountInbound || 0))),
        outbound: (acc.outbound + ((value.ringCountOutbound || 0))),
        internal: (acc.internal + ((value.ringCountInternal || 0)))
      }),
      {
        inbound: 0,
        outbound: 0,
        internal: 0
      },
    );
    
    setWidgetData(() => ({
        datasets: [{
                data: Object.values(resultObj || {}),
                backgroundColor: chartBgs,
                borderColor: chartBgs}],
        labels: Array.from(Object.keys(resultObj || {}))
    }));
  }, [deltas]);
  if (!widgetData) return <></>;
  return (
    <Doughnut
      options={{
        layout: {
            padding: 10,
        },
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    padding: 10,
                    boxWidth: 12
                }
            },
             tooltip: {
                  callbacks: {
                    label: (context: any) => {
                      const { dataset, dataIndex, label } = context;
                      let value = dataset.data?.[dataIndex];
                      return `${label} ${value === 1 ? "call" : "calls"}: ${value}`;
                    }
                  }
                },
        }
      }}
      data={widgetData as any}
    />
  );
};
export const CallDirectionDurationWidget = ({ styles,deltas , cosmetics}: {styles: any; deltas: Map<string, any> ; cosmetics: QuickWidget['cosmetics']}) => {
  const [widgetData, setWidgetData] = useState<{ datasets: Array<{ data: string[] }>; labels: string[] } | undefined>(undefined);

  useEffect(() => {
    const resultObj = Array.from(deltas.values()).reduce(
      (acc, value) => ({
        inbound: (acc.inbound + ((value.ringTimeInbound || 0))),
        outbound: (acc.outbound + ((value.ringTimeOutbound || 0))),
        internal: (acc.internal + ((value.ringTimeInternal || 0)))
      }),
      {
        inbound: 0,
        outbound: 0,
        internal: 0
      },
    );
    setWidgetData(() => ({
        datasets: [{
                data: Object.values(resultObj || {}),
                backgroundColor: chartBgs,
                borderColor: chartBgs}],
        labels: Array.from(Object.keys(resultObj || {}))
    }));
  }, [deltas]);
  if (!widgetData) return <></>;
  return (
    <Doughnut
      options={{
        layout: {
            padding: 10,
        },
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    padding: 10,
                    boxWidth: 12
                }
            },
            tooltip: {
                  callbacks: {
                    label: (context: any) => {
                      const { dataset, dataIndex, label } = context;
                      let value = dataset.data?.[dataIndex];
                      return `${label} time: ${formatSecondsToDuration(value)}`;
                    }
                  }
                },
        }
      }}
      data={widgetData as any}
    />
  );
};
export const InProgress = ({styles, queueCallStates, layout, cosmetics}: {queueCallStates: QueueCallState[] | undefined; layout: ILayoutValues, styles: any; cosmetics: QuickWidget['cosmetics']}) => { 
    if (!queueCallStates) return <>No calls.</>
    return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{queueCallStates?.length}</h1></>)
}
export const Waiting = ({styles, queueCallStates, layout, cosmetics}: {queueCallStates: QueueCallState[] | undefined; layout: ILayoutValues, styles: any; cosmetics: QuickWidget['cosmetics']}) => {
    if (!queueCallStates) return <>No calls.</>
    return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{queueCallStates?.length}</h1></>)
}
export const Answered = ({styles, queueCallStates, layout, cosmetics}: {queueCallStates: QueueCallState[] | undefined; layout: ILayoutValues, styles: any; cosmetics: QuickWidget['cosmetics']}) => {
    if (queueCallStates === undefined) return <>No calls.</>
    return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{queueCallStates}</h1></>)
}
export const Abandoned = ({styles, queueCallStates, layout, cosmetics}: {queueCallStates: QueueCallState[] | undefined; layout: ILayoutValues, styles: any; cosmetics: QuickWidget['cosmetics']}) => {
    if (queueCallStates === undefined) return <>No calls.</>
    return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{queueCallStates}</h1></>)
}
export const RaiseHandUsers = ({cosmetics, styles, users, layout} : {cosmetics: QuickWidget["cosmetics"]; styles: any, layout: ILayoutValues; users: any; }) => {  
  const [handRaisedUsers, setHandRaisedUsers] = useState<Array<any>>([]);
      
  useEffect(() => {
    if (users === undefined) return;
    const emergencyMap = Array.from(users.values()).filter((user: any) => user?.handRaised);
    if (hash(handRaisedUsers || []) === hash(emergencyMap)) return;
    setHandRaisedUsers(emergencyMap.map((user: any) => ({
      name: user.name,
      handRaised: user.handRaised
    })))
  }, [users])

  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10}}>
      <PanTool className={styles.kpiBigText} style={{fontSize:  `${layout.h * 0.9}em`}} />
      <Tooltip arrow placement='bottom' title={handRaisedUsers.map((user) => (<div style={{fontSize:  `${layout.h /5}em`}}>{user.name}</div>))} >
        <h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{handRaisedUsers.length}</h1>
      </Tooltip>
      
    </div>
  )
}
export const CallbackRequests = ({cosmetics, styles, queueCallStates, layout} : {cosmetics: QuickWidget["cosmetics"]; styles: any; queueCallStates: QueueCallState[] | undefined; layout: ILayoutValues}) => {
 if (queueCallStates === undefined) return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{0}</h1></>)
    return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{queueCallStates}</h1></>)
}
export const UnresolvedVoicemails = ({cosmetics, styles, queueCallStates, layout} : {cosmetics: QuickWidget["cosmetics"]; styles: any; queueCallStates: QueueCallState[] | undefined; layout: ILayoutValues}) => {
 if (queueCallStates === undefined) return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{0}</h1></>)
    return (<><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{queueCallStates}</h1></>)
}
export const TopPerformerCompletedCalls = ({cosmetics, historicalUsers, styles, accessToken, deltas, layout} : {layout: ILayoutValues; styles: any; accessToken: string; historicalUsers: any; deltas: Map<string, any>, cosmetics: QuickWidget["cosmetics"]}) => {
    const [users, setUsers] = useState(new Map())

  useEffect(() => {
    if (historicalUsers) {
      const namesForWidget = ["Sy Constantin", "John France", "Mitchell David Roy", "Tatiana Klimova"]

    const newMap = new Map();
    historicalUsers.forEach((user: any) => {
      if (user.name === namesForWidget.find((name) => name === user.name)) {
        newMap.set(user.name, user)
      }
    })
    setUsers(newMap)
    }
  }, [historicalUsers])

  return (
    <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
      <div className={styles.descriptorBlock}>
        <img src={`${Array.from(users?.values())[0]?.uri}?access_token=${accessToken}`} onError={(e: any) => {e.target.src = "./default-user-image.ico"}} alt="pfp" style={{width: `${layout.h * (0.6)}em`, height: `${layout.h * (0.6)}em`, borderRadius: '50%'}} />
        <div>
          <h1 style={{fontSize:  `${layout.h * (0.2)}em`}} className={styles.descriptorTitle}>{Array.from(users?.values())[0]?.name}</h1>
          <div className={styles.subText}>
            <PhoneTwoTone className={styles.subTextIcon} fontSize="small" />{Number(Array.from(users?.values())[0]?.id?.slice(0,2)) + 5}</div>
        </div>
      </div>
      <div className={styles.descriptorBlock}>
       {Array.from(users.values())
        .sort((a, b) => {
          const aNum = parseInt(a.id.match(/\d+/)?.[0] ?? "0", 10);
          const bNum = parseInt(b.id.match(/\d+/)?.[0] ?? "0", 10);
            return bNum - aNum;
        })
        .slice(1)
       .map((user: any) => (
        <div className={styles.descriptorBlock}>
          <img src={`${user.uri}?access_token=${accessToken}`} onError={(e: any) => {e.target.src = "./default-user-image.ico"}} alt="pfp" style={{width: 40, height: 40, borderRadius: 50}} />
          <div>
            <h1 style={{fontSize: `${layout.h * (0.15)}em`, margin: 0, textAlign: 'center', color: cosmetics?.color || "inherit"}}>{user.name}</h1>
            <div className={styles.subText}>
              <Phone className={styles.subTextIcon} fontSize="small" />{Number(user.id.slice(0,2)) + 5}</div>
          </div>
        </div>
       ))}
      </div>
    </div>
  )
}
export const TopPerformersSentiment = ({cosmetics, historicalUsers, styles, accessToken, deltas, layout} : {layout: ILayoutValues; styles: any; accessToken: string; historicalUsers: any; deltas: Map<string, any>, cosmetics: QuickWidget["cosmetics"]}) => {
  const [users, setUsers] = useState(new Map())



  useEffect(() => {
    if (historicalUsers) {
      const namesForWidget = ["Sy Constantin", "John France", "Mitchell David Roy", "Tatiana Klimova"]

    const newMap = new Map();
    historicalUsers.forEach((user: any) => {
      if (user.name === namesForWidget.find((name) => name === user.name)) {
        newMap.set(user.name, user)
      }
    })
    setUsers(newMap)
    }
  }, [historicalUsers])


  return (
    <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
      <div className={styles.descriptorBlock}>
        <img src={`${Array.from(users.values())[3]?.uri}?access_token=${accessToken}`} onError={(e: any) => {e.target.src = "./default-user-image.ico"}} alt="pfp" style={{width: `${layout.h * (0.82)}em`, height: `${layout.h * (0.82)}em`, borderRadius: '50%'}} />
        <div>
          <h1 style={{fontSize:  `${layout.h * (0.2)}em`, color: cosmetics?.color || 'inherit'}} className={styles.descriptorTitle}>{Array.from(users.values())[3]?.name}</h1>
          <div className={styles.subText} style={{color: cosmetics?.color || 'inherit'}}><SentimentVerySatisfiedTwoTone  className={styles.subTextIcon} fontSize="small"  style={{color: sentimentBgs[4]}} /> 4.8 </div>
          <div className={styles.subText} style={{color: cosmetics?.color || 'inherit'}}><PhoneTwoTone className={styles.subTextIcon} fontSize="small" />{Number(Array.from(users.values())[3]?.id?.slice(0,2)) + 5}</div>
        </div>
      </div>
      <div className={styles.descriptorBlock}>
       {Array.from(users.values())
      .slice(0, -1)
      .sort((a, b) => Number(b.id.slice(2) ? 1 : -1)
)
       .map((user: any) => (
        <div className={styles.descriptorBlock}>
          <img src={`${user.uri}?access_token=${accessToken}`} onError={(e: any) => {e.target.src = "./default-user-image.ico"}} alt="pfp" style={{width: 40, height: 40, borderRadius: 50}} />
          <div>
            <h1 style={{fontSize: `${layout.h * (0.15)}em`, margin: 0, textAlign: 'center', color: cosmetics?.color || "inherit"}}>{user.name}</h1>
            <div className={styles.subText} style={{color: cosmetics?.color || 'inherit'}}><SentimentSatisfiedAltTwoTone  className={styles.subTextIcon} fontSize="small"  style={{color: sentimentBgs[3]}} /> 4.{Number(user?.id?.slice(0,1))} </div>
            <div className={styles.subText}><Phone className={styles.subTextIcon} fontSize="small" />{Number(user?.id?.slice(0,2)) + 5}</div>
          </div>
        </div>
       ))}
      </div>
    </div>
  )
};
export const CustomerSatisfactionGauge = ({cosmetics, styles, layout} : {cosmetics: QuickWidget["cosmetics"], styles: any, layout: ILayoutValues}) => {

  console.log("CUSTOMER SATISFACTION GAUGE RENDERED")
  return (
    <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'center', height: '100%'}}>
  {/* <div style={{ marginRight: '20px' }}>
    <h1>CSAT</h1>
    <h2 className={styles.gridItemText}>28 Calls Analyzed</h2>
  </div> */}
  {/* <div style={{ height: '100%', width: "100%"}}> */}
    <Doughnut
      plugins={[needle]}
      options={{
        cutout: "67%",
        layout: {
          padding: 40,
        },
        animation: false,
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        },
      }}
      data={{
        labels: ["Very Positive", "Positive", "Neutral", "Negative", "Very Negative"],
        datasets: [
          {
            data: [1, 1, 1, 1, 1],
            backgroundColor: sentimentBgs,
            borderColor: sentimentBgs,
            borderWidth: 1,
            circumference: 190,
            rotation: 265,
          },
        ],
      }}
    />
  </div>
// </div>
  )
}
export const CustomImage = ({ styles, cosmetics, widgetId}: { widgetId: string | undefined; styles: any; cosmetics: QuickWidget["cosmetics"] }) => {
  const [img, setImg] = useState<string | undefined>();

  // Load from localStorage on mount
  useEffect(() => {
    try {
      const savedImg = localStorage.getItem(`customWidgetImage-${widgetId}`);
      if (savedImg) {
        setImg(savedImg);
      }
    } catch (err) {
      console.error("Failed to load image from localStorage:", err);
    }
  }, []);

  const imageLoader = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  }, []);

  const imageDropped = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const result = reader.result as string;
          setImg(result);
          localStorage.setItem(`customWidgetImage-${widgetId}`, result);
        } catch (err) {
          console.error("Error saving image to localStorage:", err);
        }
      };
      reader.readAsDataURL(file);
    }
  }, []);

  return (
    <div className={styles.container} onDrop={imageDropped} onDragOver={imageLoader}>
      {img ? (
        <img src={img} alt="dragged-img" loading="lazy" className={styles.img} />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 10,
            background: "#8787871a",
            borderRadius: 10,
          }}
        >
          <Publish fontSize="large" />
          <div style={{ opacity: "0.5" }}>Drag and drop your image here.</div>
        </div>
      )}
    </div>
  );
};
export const CustomCounter = ({styles, layout, cosmetics, widgetId} : {widgetId: string|undefined; styles: any; layout: ILayoutValues; cosmetics: QuickWidget['cosmetics']}) => {
  const [editMode, setEditMode] = useState<boolean>(false);
  const [widgetText, setWidgetText] = useState("double-click to edit")
  
  console.log("WIDGET ID: ",  widgetId);

  // First spinup
  useEffect(() => {
    const storedValue = localStorage.getItem(`live-custom-widget-${widgetId}`) || "double-click to edit";
    setWidgetText(storedValue)
  }, [])

  const handleEditMode = useCallback(() => {
    setEditMode((prev) => !prev)
  }, [editMode])

  const handleWidgetText = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    if (value === null || value === undefined || value === "") {
      setWidgetText("0")
    } else {
    setWidgetText(value)
    }
  }, [widgetText])

  const handleSubmit = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "enter") {
      setEditMode(false)
    }
  }, [widgetText])

  useEffect(() => {
    localStorage.setItem(`live-custom-widget-${widgetId}`, widgetText)
  }, [widgetText])
  


  return (
      <>
      {
        !editMode && (
          <h1 onDoubleClick={handleEditMode} className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize: widgetText === "double-click to edit" ?  `${layout.h * (0.5)}em` : `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>
            {widgetText}
          </h1>
        )
      }
      {
        editMode && (
         <ClickAwayListener onClickAway={handleEditMode}>
          <span>
            <input defaultValue={widgetText} placeholder='0' onChange={handleWidgetText} onKeyDown={handleSubmit} />
            <button onClick={handleEditMode} type="button">go</button>
          </span>
         </ClickAwayListener>
        )
      }
      </>
  )
}
export const PrimaryTopics = ({styles, cosmetics, layout} : {layout: ILayoutValues; styles: any; cosmetics: QuickWidget['cosmetics']}) => {
  return (
    <div className={styles.container} style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
    }}>
      <div className={styles.wordCloudRow}>
        <h1 className={`${styles.wordCloudHeader} ${styles.Billing}`}>Billing</h1>
        <h1 className={`${styles.wordCloudHeader} ${styles.TechnicalSupport}`}>Technical Support</h1>
        <h1 className={`${styles.wordCloudHeader} ${styles.AccountUpdate}`}>Account Update</h1>
      </div>
      <div className={styles.wordCloudRow}>
        <div className={styles.wordCloudRow2}>
          <h1 className={`${styles.wordCloudHeader} ${styles.Cancellation}`}>Cancellation</h1>
          <h1 className={`${styles.wordCloudHeader} ${styles.ProductInquiry}`}>Product Inquiry</h1>
          <h1 className={`${styles.wordCloudHeader} ${styles.AddOns}`}>Add-Ons</h1>
        </div>
        <div className={styles.wordCloudRow2}>
          <h1 className={`${styles.wordCloudHeader} ${styles.ServiceActivation}`}>Service  Activation</h1>
         <div className={styles.wordCloudRow}>
            <h1 className={`${styles.wordCloudHeader} ${styles.FeatureInquiry}`}>Feature Inquiry</h1>
            <h1 className={`${styles.wordCloudHeader} ${styles.Customization}`}>Customization</h1>
         </div>
        </div>
        <h1 className={`${styles.wordCloudHeader} ${styles.Payment}`}>Payment</h1>
        <h1 className={`${styles.wordCloudHeader} ${styles.Onboarding}`}>Onboarding</h1>
      </div>
      <div className={styles.wordCloudRow}>
        <div className={styles.wordCloudRow2}>
        <h1 className={`${styles.wordCloudHeader} ${styles.PurchaseUpgrade}`}>Purchase Upgrades</h1>
        </div>
        <h1 className={`${styles.wordCloudHeader} ${styles.ServiceRequest}`}>Service Request</h1>
        <h1 className={`${styles.wordCloudHeader} ${styles.FeedbackCollection}`}>Feedback Collection</h1>
      </div>
       <div className={styles.wordCloudRow}>
        <h1 className={`${styles.wordCloudHeader} ${styles.ReferralProgram}`}>Referral Program</h1>
          <h1 className={`${styles.wordCloudHeader} ${styles.Troubleshooting}`}>Troubleshooting</h1>
          <h1 className={`${styles.wordCloudHeader} ${styles.AccountVerification}`}>Verification</h1>
      </div>
    </div>
  )
}
export const EcosystemExCalls = ({layout, styles, cosmetics} : {cosmetics: QuickWidget['cosmetics'], layout: ILayoutValues; styles: any}) => {
  return (
    <><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{40}</h1></>
  )
}
export const EcosystemCxCalls = ({layout, styles, cosmetics} : {cosmetics: QuickWidget['cosmetics'], layout: ILayoutValues; styles: any}) => {
  return (
    <><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{28}</h1></>
  )
}
export const EcosystemTransfersEx = ({layout, styles, cosmetics} : {cosmetics: QuickWidget['cosmetics'], layout: ILayoutValues; styles: any}) => {
  return (   
    <><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{3}</h1></>
  )
}
export const EcosystemTransfersCx = ({layout, styles, cosmetics} : {cosmetics: QuickWidget['cosmetics'], layout: ILayoutValues; styles: any}) => {
  return (
    <><h1 className={styles.kpiBigText} style={{color: cosmetics?.color || "inherit", fontSize:  `${layout.h * (1.5)}em`, margin: 0, textAlign: 'center'}}>{1}</h1></>
  )
}
export const RingCentral = ({layout} : {layout: ILayoutValues}) => {
return (
  <img style={{width: '100%', height: 'auto', objectFit: 'contain'}} alt='rc-logo' src={rcimg} />
)
}
// eslint-disable-next-line no-undef
const RenderQuickWidget = ({widgetContent, historicalUsers, accessToken, layout, users, styles, queueCallStates, widgetName, deltas }: {widgetContent: Widget; historicalUsers: any; accessToken: string; layout: ILayoutValues; queueCallStates: QueueCallState[] | undefined,  widgetName: string | undefined; deltas: Map<string, any> , styles: any; users: any}) => {
    // TODO: This code here is an unmaintainable mess. This will be swapped out for a registry instead
    switch (widgetName) {
    case 'callResults':
      return <CallResultsWidget widgetContent={widgetContent} cosmetics={widgetContent?.cosmetics}  styles={styles} deltas={deltas} />;
    case 'callDirectionCount':
        return <CallDirectionCountWidget  cosmetics={widgetContent?.cosmetics}  styles={styles} deltas={deltas} />;
    case 'callDirectionTime':
        return <CallDirectionDurationWidget  cosmetics={widgetContent?.cosmetics}  styles={styles} deltas={deltas} />;
    case  'inProgress':
        return <InProgress  cosmetics={widgetContent?.cosmetics}   styles={styles}queueCallStates={queueCallStates} layout={layout} />;   
    case  'waiting':
        return <Waiting  cosmetics={widgetContent?.cosmetics}  styles={styles} queueCallStates={queueCallStates} layout={layout} />;   
    case  'answered':
        return <Answered  cosmetics={widgetContent?.cosmetics}  styles={styles} queueCallStates={queueCallStates} layout={layout} />;   
    case  'abandoned':
        return <Abandoned cosmetics={widgetContent?.cosmetics}   styles={styles} queueCallStates={queueCallStates} layout={layout} />;   
    case  'raiseHandUsers':
        return <RaiseHandUsers  cosmetics={widgetContent?.cosmetics}  styles={styles} users={users} layout={layout} />;   
    case 'callbackRequests':
        return <CallbackRequests  cosmetics={widgetContent?.cosmetics}  styles={styles} queueCallStates={queueCallStates} layout={layout} />;
    case 'unresolvedVoicemails':
        return <UnresolvedVoicemails  cosmetics={widgetContent?.cosmetics}  styles={styles} queueCallStates={queueCallStates} layout={layout} />;
    case 'topPerformersCompletedCalls':
        return <TopPerformerCompletedCalls  cosmetics={widgetContent?.cosmetics}  layout={layout} styles={styles} accessToken={accessToken} deltas={deltas} historicalUsers={historicalUsers} />
    case 'topPerformersSentiment':
        return <TopPerformersSentiment  cosmetics={widgetContent?.cosmetics}  layout={layout} styles={styles} accessToken={accessToken} deltas={deltas} historicalUsers={historicalUsers} />
    case 'customerSatisfactionGauge': 
        return <CustomerSatisfactionGauge  cosmetics={widgetContent?.cosmetics}  layout={layout} styles={styles} />
    case 'customImage':
        return <CustomImage widgetId={widgetContent?.widgetId} cosmetics={widgetContent?.cosmetics}  styles={styles} />
    case 'customCounter':
        return <CustomCounter widgetId={widgetContent.widgetId} cosmetics={widgetContent?.cosmetics}  styles={styles} layout={layout} />
    case 'ringCentral':
      return <RingCentral layout={layout} />
    case "primaryTopics":
        return <PrimaryTopics  layout={layout} cosmetics={widgetContent?.cosmetics}  styles={styles} />
    
      case "ecosystemExCalls": 
        return <EcosystemExCalls  cosmetics={widgetContent?.cosmetics}  layout={layout} styles={styles} />
      case "ecosystemCxCalls": 
        return <EcosystemCxCalls  cosmetics={widgetContent?.cosmetics}  layout={layout} styles={styles} />
      case "ecosystemTransfersEx": 
        return <EcosystemTransfersEx cosmetics={widgetContent?.cosmetics} layout={layout} styles={styles} />
      case "ecosystemTransfersCx": 
        return <EcosystemTransfersCx cosmetics={widgetContent?.cosmetics} layout={layout} styles={styles} />
    default:
      <></>;
  }
  return <>Quick Widget not found. Try again.</>;
};

export default RenderQuickWidget;


